import { IAvatarSkin } from './avatarSkin';
import { IEvent } from './event';
import { IParticipant } from './participants';

export const ExperienceRoles = {
  Facilitator: 'FACILITATOR',
  ExperienceMember: 'EXPERIENCE_MEMBER',
} as const;

export type ExperienceRoles =
  (typeof ExperienceRoles)[keyof typeof ExperienceRoles];

export type EventParticipantStateQuestType = {
  QuestId: string;
  bIsFinish: boolean;
};

export type EventParticipantStateType = {
  bIsOliver: boolean;
  bIsTicket: boolean;
  bIsFirstJoin: boolean;
  bIsCelebrationMoment: boolean;
  TutorialTag: string;
  QuestEntities: EventParticipantStateQuestType[];
};

export interface IEventParticipant {
  role?: string;
  skinId?: string;
  participantsSound?: number;
  selectedLanguage?: string;
  gameSound?: number;
  eventId?: string;
  participantId?: string;
  experienceMode?: string;
  event?: IEvent;
  participant?: IParticipant;

  skin?: IAvatarSkin;

  dolbyToken?: string | null;
  streamChatToken?: string | null;
  streamChatMemberId?: string | null;

  isHubMultiplayer?: boolean | null;
  state?: string | null;
  assistantState?: string | null;

  isDisabled?: boolean;

  startDate?: number;
  endDate?: number;
  isDemo?: boolean;
  navigationMode?: string;
}
